import axios from 'axios'
import CampaignsRepository from './Repositories/campaigns'
import DealsRepository from './Repositories/deals'
import EmailTemplatesRepository from './Repositories/emailTemplates'
import LanguageTagsRepository from './Repositories/languageTags'
import MediaAssignments from './Repositories/mediaAssignments'
import MediasRepository from './Repositories/medias'
import MessagesRepository from './Repositories/messages'
import MessageListsRepository from './Repositories/messageLists'
import OfferRepository from './Repositories/offers'
import PackagesRepository from './Repositories/packages'
import PartnerUsersRepository from './Repositories/partnerUsers'
import ProductsRepository from './Repositories/products'
import Users from './Repositories/users'
import Venues from './Repositories/venues'
import Categories from './Repositories/categories'
import Partners from './Repositories/partners'
import Reports from './Repositories/reports'
import Statuses from './Repositories/statuses'
import Affiliates from './Repositories/affiliates'
import Resellers from './Repositories/resellers'
import Promos from './Repositories/promos'
import Locations from './Repositories/locations'
import Fields from './Repositories/fields'
import Auth from './Repositories/auth'
import Templates from './Repositories/templates'
import Agreements from './Repositories/agreements'
import Attributes from './Repositories/attributes'

const ignorErrorRoutes = ['/profile']

axios.interceptors.response.use(
    response => {
        return response
    },
    error => {
        if( error.response.config.url === '/profile' && error.response.status === 401 ) { // see if we need to go back to login screen
            return window.location = '/login';
        }
        if (ignorErrorRoutes.indexOf(error.response.config.url) > -1) return
        if (error.response.config.url === '/login' && error.response.status === 422) return

        const message =
            error.response.status +
            ' ' +
            error.response.statusText +
            ': ' +
            error.response.data.message
        
        if (typeof One === 'function') {
            One.helpers('notify', {
                align: 'center',
                type: 'danger',
                icon: 'fa fa-exclamation mr-1',
                message
            })
        }
        return Promise.reject(error)
    }
)

const isAdmin = window.location.pathname.indexOf('/superAdmin/') > -1;
const repositories = {
    campaigns: CampaignsRepository(axios, isAdmin),
    deals: DealsRepository(axios, isAdmin),
    emailTemplates: EmailTemplatesRepository(axios, isAdmin),
    languageTags: LanguageTagsRepository(axios, isAdmin),
    mediaAssignments: MediaAssignments(axios, isAdmin),
    medias: MediasRepository(axios, isAdmin),
    messages: MessagesRepository(axios, isAdmin),
    messageLists: MessageListsRepository(axios, isAdmin),
    offers: OfferRepository(axios, isAdmin),
    packages: PackagesRepository(axios, isAdmin),
    partnerUsers: PartnerUsersRepository(axios, isAdmin),
    products: ProductsRepository(axios, isAdmin),
    users: Users(axios, isAdmin),
    venues: Venues(axios, isAdmin),
    categories: Categories(axios, isAdmin),
    partners: Partners(axios, isAdmin),
    reports: Reports(axios, isAdmin),
    statuses: Statuses(axios, isAdmin),
    affiliates: Affiliates(axios, isAdmin),
    resellers: Resellers(axios, isAdmin),
    locations: Locations(axios, isAdmin),
    fields: Fields(axios, isAdmin),
    auth: Auth(axios, isAdmin),
    templates: Templates(axios, isAdmin),
    promos: Promos(axios, isAdmin),
    agreements: Agreements(axios, isAdmin),
    attributes: Attributes(axios, isAdmin),
    // METHODS
    setPartner(partnerId) {
        if( partnerId !== 'undefined' && !isNaN(partnerId) )
            axios.defaults.headers.common['BW-Admin-Partner-Id'] = partnerId
    }
}

export default repositories
